import { Injectable, inject } from '@angular/core';
import { AuthService } from '@mds/angular-core';
import { Observable, combineLatest, filter, map, shareReplay, switchMap } from 'rxjs';
import { ClaimTypes } from '../models/claim-types.model';
import { MeClient, UserScopeParameterValueModel, UserScopesModel } from './api-client';

@Injectable({
  providedIn: 'root',
})
export class UserScopesService {
  private readonly authService = inject(AuthService);
  private readonly meClient = inject(MeClient);

  private readonly isAuthenticatedAndLoaded$ = combineLatest([
    this.authService.isLoaded$,
    this.authService.isAuthenticated$,
  ]).pipe(
    filter(([isLoaded, isAuthenticated]) => isLoaded && isAuthenticated),
    map(() => undefined)
  );

  private readonly userScopes$ = this.isAuthenticatedAndLoaded$.pipe(
    switchMap(() => this.meClient.getScopes(true)),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  private readonly organizationScopeParameterValues$ = this.isAuthenticatedAndLoaded$.pipe(
    switchMap(() => this.meClient.getScopeParameterValues(ClaimTypes.Organization, true)),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  getScopes(): Observable<UserScopesModel> {
    return this.userScopes$;
  }

  getOrganizationScopeParameterValues(): Observable<UserScopeParameterValueModel[]> {
    return this.organizationScopeParameterValues$;
  }
}
